//@flow
import * as Immutable from 'immutable';

import { Skills } from 'common/models/flow/Skills';
import StringUtils from 'common/utils/StringUtils';
import { without, intersection } from 'common/utils/ImmutableUtils';
import type { SkillsModelType } from 'common/models/flow/Skills';

class InternalSkills extends Skills {
    static fromJS(json: SkillsModelType): InternalSkills {
        const state: Object = Object.assign({}, json);
        state.tags = Immutable.List(state.tags);
        return new this(Immutable.Map(state));
    }

    getCommonSkills(skills: InternalSkills): InternalSkills {
        const commonSkillTags = intersection(this.tags, skills.tags);
        const skill = { tags: commonSkillTags.toJS() };
        return InternalSkills.fromJS(skill);
    }

    getSortedSkills(commonSkills?: ?InternalSkills): InternalSkills {
        let sortedSkillTags = this.tags.sort(
            StringUtils.alphabeticalComparator
        );

        if (commonSkills && commonSkills.tags.size > 0) {
            // sort and seperate common
            const sortedCommonSkillsTags = commonSkills.tags.sort(
                StringUtils.alphabeticalComparator
            );
            const sortedSkillTagsWithoutCommon = without(
                sortedSkillTags,
                sortedCommonSkillsTags
            );

            sortedSkillTags = sortedCommonSkillsTags.concat(
                sortedSkillTagsWithoutCommon
            );
        }

        const sortedSkills = InternalSkills.fromJS({ tags: [] }).setTags(
            sortedSkillTags
        );
        return sortedSkills;
    }

    getSortedSkillText(commonSkills?: ?InternalSkills): string {
        return this.getSortedSkills(commonSkills).tags.join(', ');
    }

    isEmpty(): boolean {
        if (this.tags.size) {
            return false;
        }
        return true;
    }
}

export { InternalSkills as Skills };
